import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "91movie_favorites";

function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((i) => typeof i === "string") : [];
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
  }, []);

  const persist = useCallback((next: string[]) => {
    setFavorites(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // 本地存储不可用时静默处理
    }
  }, []);

  const toggle = useCallback(
    (id: string) => {
      const current = readFavorites();
      const exists = current.includes(id);
      const next = exists ? current.filter((i) => i !== id) : [...current, id];
      persist(next);
      return !exists;
    },
    [persist],
  );

  const isFavorite = useCallback((id: string) => favorites.includes(id), [favorites]);

  return { favorites, isFavorite, toggle };
}